import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import { EmailAddressGenerateCodeInput } from '@libs/types/src/inbox/input-type/email-address.generate-code-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { InboxUpdateInput } from '@libs/types/src/inbox/input-type/inbox.update-input';
import { EmailAddressVerifyCodeInput } from '@libs/types/src/inbox/input-type/email-address.verify-code-input';
import { OkObject } from '@it2go/types';
import { EmailAddressGenerateCodeObject } from '@libs/types/src/inbox/object-type/email-address-generate-code.object';

@Injectable({ providedIn: 'root' })
export class EmailAddressGqlService extends GqlServiceV2 {

    // to get emailAddresses use getEmailInboxes from InboxGqlService

    createEmailAddressGenerateCode(input: EmailAddressGenerateCodeInput): Promise<EmailAddressGenerateCodeObject> {
        return this.mutate(`
            mutation($input: EmailAddressGenerateCodeInput!) {
                emailAddress {
                    createGenerateCode(input: $input) {
                        domainSupported
                        emailAddressValidForMicrosoft
                    }
                }
            }`,
            { input },
        );
    }

    createEmailAddressVerifyCode(input: EmailAddressVerifyCodeInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: EmailAddressVerifyCodeInput!) {
                emailAddress {
                    createVerifyCode(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    restoreEmailAddress(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                emailAddress {
                    restore(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    updateEmailAddress(input: InboxUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxUpdateInput!) {
                emailAddress {
                    update(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteEmailAddress(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                emailAddress {
                    delete(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
